import { USER_ROLES } from '../consts/userRoles';

/**
 * Checks access based on role or workflow assignee ownership.
 * @param {string} userRole - The user's role
 * @param {string} assignedTo - Azure object id of assigned user
 * @param {string} currentUserId - Azure object id of current user
 * @returns {boolean} True if user is admin or assignee
 */
export const checkAccess = (userRole, assignedTo, currentUserId) => {
  if (userRole === USER_ROLES.VIEWER) {
    return false;
  }

  const isAdmin = userRole === USER_ROLES.ADMIN;
  const isAssignee = !!assignedTo && assignedTo === currentUserId;

  return isAdmin || isAssignee;
};
